import {combineReducers} from 'redux';
import {reducer as form} from 'redux-form';
import {reducer as toastr} from 'react-redux-toastr';
import {pendingTasksReducer as pendingTasks} from 'react-redux-spinner';
import {routerReducer as routing} from 'react-router-redux';

// features reducers
import shared from 'shared/reducer';
import registration from './features/registration/reducer';
import tournament from './features/tournament/reducer';
import admin from './features/admin/rootReducer';
import finance from './features/finance/rootReducer';

const rootReducer = combineReducers({
  routing,
  pendingTasks,
  toastr,
  form,
  shared,
  registration,
  tournament,
  admin,
  finance
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/rootReducer.js